import React, { useEffect, useState } from "react";
export interface SelectInputProps {
  onChange: (event: React.ChangeEvent<HTMLInputElement>, value: string) => void;
  placeholder?: string;
  value?: string;
  label?: string;
  primaryTextColor?: string;
  accentColor?: string;
  errorColor?: string;
  errorMessage?: string;
  options: { value: string; label: string }[];
  id: string;
}
export const SelectInput = (props: SelectInputProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const componentRef = React.useRef<HTMLUListElement>(null);
  const handleDropdownOpen = () => {
    console.log("scroll");
    const container = window.document.getElementById("scroller2");
    const dropdown = componentRef.current;

    if (container && dropdown) {
      const containerRect = container.getBoundingClientRect();
      const dropdownRect = dropdown.getBoundingClientRect();
      console.log(dropdownRect.bottom, containerRect.bottom);
      if (dropdownRect.bottom > containerRect.bottom) {
        container.scrollTop += dropdownRect.bottom - containerRect.bottom + 30;
        //scroll to bottom
        // console.log("scrolling");
        // container.scrollTo(0, container.scrollHeight);
      }
    }
  };

  const handleOptionClick = (e: any, option: { label: string }) => {
    props.onChange(e, option.label);
    setIsOpen(false);
  };

  const close = async () => {
    console.log("sleep");
    await new Promise((resolve) => setTimeout(resolve, 150));
    setIsOpen(false);
  };

  function getOppositeColor(hex: string) {
    // Remove '#' if present
    hex = hex.replace(/^#/, "");

    // Convert to RGB
    let r = parseInt(hex.substring(0, 2), 16);
    let g = parseInt(hex.substring(2, 4), 16);
    let b = parseInt(hex.substring(4, 6), 16);

    // Get the opposite color (invert RGB)
    r = 255 - r;
    g = 255 - g;
    b = 255 - b;

    // Convert back to HEX
    let oppositeHex = `#${r.toString(16).padStart(2, "0")}${g
      .toString(16)
      .padStart(2, "0")}${b.toString(16).padStart(2, "0")}`;

    return oppositeHex.toUpperCase();
  }

  const getSelectedColor = (option: { label: string; value: string }) => {
    if (props.value && props.value === option.value) {
      if (props.accentColor) {
        return props.accentColor;
      } else {
        return getOppositeColor(props.primaryTextColor!);
      }
    } else {
      return "#444444";
    }
  };

  useEffect(() => {
    if (isOpen) {
      handleDropdownOpen();
    }
  }, [isOpen]);

  return (
    <div style={{ width: "100%", margin: "10px 0px 20px 10px" }}>
      <div
        style={{
          width: "fit-content",
          paddingLeft: "2px",
          paddingRight: "4px",
          marginBottom: "2px",
          color: props.primaryTextColor ?? "#fff",
          fontSize: "14px",
          fontWeight: 600,
        }}
      >
        {props.label}
      </div>
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          position: "relative",
        }}
      >
        <input
          id={props.id}
          type="text"
          value={props.value}
          readOnly
          onClick={() => setIsOpen((prev) => !prev)}
          onBlur={() => close()}
          placeholder={props.placeholder}
          style={{
            padding: "0",
            color: props.primaryTextColor,
            borderColor: props.primaryTextColor,
            backgroundColor: "transparent",
            borderRadius: "6px",
            textAlign: "center",
            border: "1px solid",
            width: "100%",
            cursor: "pointer",
            height: "38px",
          }}
        />
        <div
          style={{
            position: "absolute",
            right: "12px",
            top: "8px",
            cursor: "pointer",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
          onClick={() => {
            if (!isOpen) {
              document.getElementById(props.id)?.focus();
            }
            setIsOpen(!isOpen);
          }}
        >
          <div
            style={{
              borderColor: props.primaryTextColor,
              borderLeft: "1px solid",
              borderRight: "0px solid",
              height: "20px",
              marginRight: "12px",
            }}
          ></div>
          <svg
            width="20"
            height="16"
            viewBox="0 0 20 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.90735e-06 3.33882C0.00308228 2.80387 0.116661 2.27562 0.333303 1.78865C0.560415 1.26198 0.931032 0.813264 1.4009 0.496092C1.87076 0.17892 2.42001 0.00669988 2.98305 0L17.015 0C17.578 0.00669988 18.1273 0.17892 18.5972 0.496092C19.067 0.813264 19.4376 1.26198 19.6648 1.78865C19.9448 2.39465 20.0526 3.06888 19.976 3.73449C19.8994 4.4001 19.6414 5.03032 19.2315 5.55335L12.2155 14.2411C11.9501 14.5818 11.6131 14.8569 11.2293 15.046C10.8456 15.2351 10.425 15.3333 9.99903 15.3333C9.57302 15.3333 9.15249 15.2351 8.76874 15.046C8.385 14.8569 8.04791 14.5818 7.78258 14.2411L0.766592 5.55335C0.269764 4.92711 -0.000940323 4.1451 1.90735e-06 3.33882Z"
              fill={props.primaryTextColor}
            />
          </svg>
        </div>
        {isOpen && (
          <ul
            ref={componentRef}
            style={{
              listStyleType: "none",
              borderColor: props.primaryTextColor,
              backgroundColor: props.primaryTextColor,
              zIndex: 1000,
              position: "absolute",
              marginTop: "40px",
              width: "100%",
              border: "1px solid",
              borderRadius: "12px",
              textAlign: "start",
              maxHeight: "200px",
              overflow: "auto",
              padding: "0",
            }}
          >
            {props.options.map((option, index) => (
              <li
                key={index}
                style={{
                  marker: "none",
                  color: getSelectedColor(option),
                  padding: "8px 12px",
                  cursor: "pointer",
                }}
                onClick={(e) => handleOptionClick(e, option)}
              >
                {option.label}
              </li>
            ))}
          </ul>
        )}
      </div>{" "}
      {props.errorMessage && (
        <p
          style={{
            color: props.errorColor ?? "#fa7373",
            fontSize: "12px",
            marginTop: "2px",
            textAlign: "left",
          }}
        >
          {props.errorMessage}
        </p>
      )}
    </div>
  );
};
